import React from 'react';
import MatchDateHomepage from './matchDateHomepage';
import Team from './team';
import MatchResult from './matchResult.js';
import MobileMatchDate from './mobileMatchDate.js';
const blockName = 'match-container-component';
export default function MatchContainer({ homeTeam, awayTeam, result, date, status }){
  return (
    <div className={ blockName }>
      <MobileMatchDate date={ date } />
      <MatchDateHomepage date={ date } />
      <div className={ `${ blockName }__teams-container` }>
        <Team name={ homeTeam.name } image={ homeTeam.image } />
        <MatchResult result={ result } status={ status } />
        <Team name={ awayTeam.name } image={ awayTeam.image } />
      </div>
    </div>
  );
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/schedule/components/matchItemHomepage.js